import React, { useEffect, useState } from "react";
import EmailVerify from "./Components/Dashbord/EmailVerify";
import "./Packages.css"; // We'll create this file next
import { getuserdata } from "../../../services/apiService";

const Packages = () => {
    const [userdata, setUserdata] = useState({});
    const [tabsest, setTabseset] = useState("Personal Details");

    useEffect(() => {
        const fetchData = async () => {
            const userData = await getuserdata('full');
            console.log("userData", userData);
            if (userData) {
                setUserdata(userData);
            }
        };
        fetchData();
    }, []);

    const packages = [
        {
            name: "Free",
            price: 0,
            period: "Monthly",
            features: {
                services: 5,
                brochures: 1,
                articles: 2,
                awards: 2,
                memberships: 2,
                quickChat: false,
                bookings: false,
                featuredProfile: false,
                featuredDays: 0,
                duration: 30,
                socialPosts: 2,
                socialVideos: 1,
                autoPost: false,
                profileWebsite: false,
                hms: false
            },
            key: "free"
        },
        {
            name: "Basic",
            price: 1500,
            period: "Monthly",
            features: {
                services: 15,
                brochures: 3,
                articles: 5,
                awards: 5,
                memberships: 5,
                quickChat: true,
                bookings: true,
                featuredProfile: false,
                featuredDays: 0,
                duration: 30,
                socialPosts: 5,
                socialVideos: 2,
                autoPost: false,
                profileWebsite: false,
                hms: false
            },
            key: "basic"
        },
        {
            name: "Business",
            price: 2500,
            period: "Monthly",
            features: {
                services: 30,
                brochures: 10,
                articles: 15,
                awards: 10,
                memberships: 10,
                quickChat: true,
                bookings: true,
                featuredProfile: true,
                featuredDays: 100,
                duration: 30,
                socialPosts: 30,
                socialVideos: 10,
                autoPost: true,
                profileWebsite: true,
                hms: true
            },
            key: "business"
        }
    ];

    return (
        <div className="packages-container">
            {userdata.activation_key == null && <EmailVerify />}
            
            <div className="packages-header">
                <h1>Choose Your Package</h1>
                <p>Select the perfect plan for your needs</p>
            </div>

            <div className="packages-grid">
                {packages.map((pkg) => (
                    <div key={pkg.key} className="package-card">
                        <div className="package-header">
                            <h3>{pkg.name}</h3>
                            <div className="package-price">
                                <span className="currency">₹</span>
                                <span className="amount">{pkg.price}</span>
                                <span className="period">/{pkg.period}</span>
                            </div>
                        </div>
                        
                        <div className="package-features">
                            <ul>
                                <li>
                                    <span className="feature-label">Services per specialty:</span>
                                    <span className="feature-value">{pkg.features.services}</span>
                                </li>
                                <li>
                                    <span className="feature-label">Brochures:</span>
                                    <span className="feature-value">{pkg.features.brochures}</span>
                                </li>
                                <li>
                                    <span className="feature-label">Articles:</span>
                                    <span className="feature-value">{pkg.features.articles}</span>
                                </li>
                                <li>
                                    <span className="feature-label">Awards:</span>
                                    <span className="feature-value">{pkg.features.awards}</span>
                                </li>
                                <li>
                                    <span className="feature-label">Memberships:</span>
                                    <span className="feature-value">{pkg.features.memberships}</span>
                                </li>
                                <li>
                                    <span className="feature-label">Quick Chat:</span>
                                    <span className="feature-value">
                                        {pkg.features.quickChat ? "✓" : "✗"}
                                    </span>
                                </li>
                                <li>
                                    <span className="feature-label">Bookings:</span>
                                    <span className="feature-value">
                                        {pkg.features.bookings ? "✓" : "✗"}
                                    </span>
                                </li>
                                <li>
                                    <span className="feature-label">Featured Profile:</span>
                                    <span className="feature-value">
                                        {pkg.features.featuredProfile ? "✓" : "✗"}
                                    </span>
                                </li>
                                <li>
                                    <span className="feature-label">Featured Days:</span>
                                    <span className="feature-value">
                                        {pkg.features.featuredDays || "N/A"}
                                    </span>
                                </li>
                                <li>
                                    <span className="feature-label">Duration:</span>
                                    <span className="feature-value">
                                        {pkg.features.duration} days
                                    </span>
                                </li>
                                <li>
                                    <span className="feature-label">Social Posts:</span>
                                    <span className="feature-value">
                                        {pkg.features.socialPosts}
                                    </span>
                                </li>
                                <li>
                                    <span className="feature-label">Social Videos:</span>
                                    <span className="feature-value">
                                        {pkg.features.socialVideos}
                                    </span>
                                </li>
                                <li>
                                    <span className="feature-label">Auto Post:</span>
                                    <span className="feature-value">
                                        {pkg.features.autoPost ? "✓" : "✗"}
                                    </span>
                                </li>
                                <li>
                                    <span className="feature-label">Profile Website:</span>
                                    <span className="feature-value">
                                        {pkg.features.profileWebsite ? "✓" : "✗"}
                                    </span>
                                </li>
                                <li>
                                    <span className="feature-label">HMS:</span>
                                    <span className="feature-value">
                                        {pkg.features.hms ? "✓" : "✗"}
                                    </span>
                                </li>
                            </ul>
                        </div>

                        <button className="package-button" data-key={pkg.key}>
                            Buy Now
                        </button>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default Packages;
